import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, inject } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { ApiUrls } from "../backoffice-urls";

@Injectable({
  providedIn: "root",
})
export class DocumentCategoryService {
  private http = inject(HttpClient);
  private apiUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.apiUrl = this.config.apiUrl;
  }

  getDocumentCategoryList(body: any) {
    const link = this.apiUrl + ApiUrls.documentCategoryGetList;
    return this.http.post<any>(link, body);
  }

  // Returns all document types. Path is inline because backoffice-urls.ts has no entry for it.
  getDocumentTypeList(body: any = { pageIndex: 0, pageSize: 0, searchTerm: '' }) {
    const link = `${this.apiUrl}/api/DocumentType/getList`;
    return this.http.post<any>(link, body);
  }

  getDocumentCategoryById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getDocumentCategoryById}/${id}`;
    return this.http.get<any>(link);
  }

  createDocumentCategory(body: any) {
    const link = this.apiUrl + ApiUrls.createDocumentCategory;
    return this.http.post<any>(link, body);
  }

  updateDocumentCategory(body: any) {
    const link = this.apiUrl + ApiUrls.updateDocumentCategory;
    return this.http.post<any>(link, body);
  }

  deleteDocumentCategory(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteDocumentCategory}/${id}`;
    return this.http.post<any>(link, { id });
  }
}
